import React from 'react';

import { ReactComponent as CircleCheck } from '../../../assets/icons/CircleCheck.svg';
import { ReactComponent as XIcon } from '../../../assets/icons/XIcon.svg';
import { ReactComponent as CircleExclamation } from '../../../assets/icons/CircleExclamation.svg';
import { ReactComponent as TriangleAdmiration } from '../../../assets/icons/TriangleAdmiration.svg';

import classes from './ToastContent.module.scss';

const icons = {
  success: CircleCheck,
  alert: TriangleAdmiration,
  info: CircleExclamation
};
const ToastContent = ({ type, message, callback }) => {
  const Icon = icons[type] ? icons[type] : CircleExclamation;

  const closeHandler = () => {
    callback();
  };

  return (
    <div className={`${classes.content} ${classes[`toast-${type}`]}`}>
      <Icon className={classes.icon} />
      <div className={`${classes.text} semibold-16`}>
        <span>{message}</span>
      </div>
      <div className={classes['content-icon']}>
        <XIcon name='closeToast' className={classes.close} onClick={closeHandler} />
      </div>
    </div>
  );
};

export default ToastContent;
